import React, { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import { useNavigate } from "react-router-dom";
import "./UserDashSidebar.css";

const Sidebar = ({ activeTab, setActiveTab, onLogout }) => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  const menuItems = [
    { id: "nadzorna-plosca", label: "Nadzorna plošča", icon: "fa-solid fa-gauge-high" },
    { id: "priljubljeni-oglasi", label: "Priljubljeni oglasi", icon: "fas fa-heart" },
    { id: "neodgovorjena-vprasanja", label: "Neodgovorjena vprašanja", icon: "fas fa-envelope" },
    { id: "nastavitve-profila", label: "Nastavitve profila", icon: "fas fa-user-cog" },
    //{ id: "nastavitve-zasebnosti", label: "Nastavitve zasebnosti", icon: "fas fa-lock" },
    { id: "faq", label: "Pogosta vprašanja", icon: "fa-solid fa-circle-question" },
    { id: "logout", label: "Odjava", icon: "fas fa-sign-out-alt" },
  ];

  const handleTabClick = async (tabId) => {
    if (tabId === "logout") {
      await onLogout();
      navigate("/prijava");
    } else {
      setActiveTab(tabId);
      // SPREMEMBA TUKAJ: Navigacija na čisti URL
      navigate(`/moj-racun/${tabId}`);
    }
  };

  return (
    <div className="sidebar bg-light">
      <div className="sidebar-header text-center py-4">
        <img
          src="https://slike.bazarc.si/User_Icon.svg"
          alt="User"
          className="user-avatar rounded-circle mb-2"
        />
        {user ? (
          <>
            <h3>{user.username}</h3>
            <p>Uporabnik</p>
          </>
        ) : (
          <>
            <h3>Guest</h3>
            <p>Please log in</p>
          </>
        )}
      </div>
      <ul className="menu-list list-group">
        {menuItems.map((item) => (
          <li
            key={item.id}
            className={`menu-item list-group-item ${
              activeTab === item.id ? "active" : ""
            }`}
            onClick={() => handleTabClick(item.id)}
          >
            <i className={`${item.icon} me-2`}></i>
            <span>{item.label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;